import {queryHrList} from '@api/hr/hr';
import localDb from '@util/localDb';

// 按模块的action, reducer整合体
const GET_STAFF_LIST = 'GET_STAFF_LIST';

// Action
export function getStaffList(payload) {
  const current = payload.current ? payload.current : 1;
  const start = current;
  return dispatch => {
    queryHrList({
      ...payload,
      start,
    }).then(res => {
      if (res.statusCode === 200) {
        localDb.set(GET_STAFF_LIST, res.data);
        return dispatch({
          type: GET_STAFF_LIST,
          data: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              current,
              pageSize: 15,
            },
          },
        });
      }
    });
  };
}

// Reducer
export function staffList(
  state = [
    {
      list: [],
      pagination: {},
    },
  ],
  action,
) {
  switch (action.type) {
    case GET_STAFF_LIST:
      return action.data || [];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/staff_list.js